import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { EPProvider, Box, Flex, WebviewWrapper } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'
import { messages } from 'commons/js/messages'
import { defaultLocale, currentLocale } from 'commons/js/locale'
import Logo from 'commons/js/ui/Logo'
import connectUrl from 'commons/js/components/connectUrl'
import getTheme from 'commons/js/theme/getTheme'
import { RentalCarContractProcessMainContainer, RentalCarContractProcessWrapper } from 'rental-car-contract/js/ui/RentalCarContractProcess'
import FatalErrorModal from '../../components/FatalErrorModal'
import Content from './Content'
import DownloadAppBlock from './DownloadAppBlock'
import { isWebview } from '@elparking/utils'
import { AnalyticsProvider } from '@elparking/analytics'
import { getConstant } from 'commons/js/constants'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const RentalCarDetailContainer = ({
    user,
    requestUser,
    isLoading,
    rentalCarContract: booking,
    request,
    token,
    id,
    error,
    isWebView,
 }) => {
    useEffect(() => {
        (!user || !user.id) && !isLoading && requestUser()
    }, [user, isLoading, requestUser])

    useEffect(() => {
        trackTealiumEvent(RentalCarEvents.showBookingDetail)
    }, [])
    const isLoggedIn = !isLoading && user && user.id
    return (<div>
        <IntlProvider locale={currentLocale} defaultLocale={defaultLocale} messages={messages[currentLocale]}>
            <EPProvider theme={getTheme()} {...convertConstantToEPProviderFormat()}>
                <AnalyticsProvider analyticService={window.utag}>
                    <RentalCarContractProcessMainContainer>
                        <Box display={isWebView ? 'none' : 'block'}>
                            <RentalCarContractProcessWrapper>
                                <Flex as='a' width='100%' justifyContent={['center', 'flex-start']} m='1em 0' href={getConstant('FIREBASE_WEB_LINK_MUTUAMAS')}>
                                    <Logo height='32px' />
                                </Flex>
                            </RentalCarContractProcessWrapper>
                        </Box>
                        <RentalCarContractProcessWrapper>
                            {isLoggedIn &&
                            <WebviewWrapper fallbackComponent={<DownloadAppBlock bookingId={id} />}>
                                <Content id={id} booking={booking} error={error} user={user} token={token} isLoading={isLoading} request={request} isWebView={isWebview} />
                            </WebviewWrapper>
                        }
                        </RentalCarContractProcessWrapper>
                    </RentalCarContractProcessMainContainer>
                    <FatalErrorModal />
                </AnalyticsProvider>
            </EPProvider>
        </IntlProvider>
    </div>)
}

/* istanbul ignore next */
function mapParamsToProps ({ id }) {
    return {
        id: parseInt(id),
    }
}
/* istanbul ignore next */
RentalCarDetailContainer.propTypes = {
    user: PropTypes.object,
    navigateTo: PropTypes.func,
    requestUser: PropTypes.func,
    request: PropTypes.func,
    isLoading: PropTypes.bool,
    rentalCarContract: PropTypes.object,
    id: PropTypes.number,
    error: PropTypes.any,
    token: PropTypes.any,
    isWebView: PropTypes.bool,
}
/* istanbul ignore next */
RentalCarDetailContainer.defaultProps = {
    error: false,
    isLoading: false,
    isUpdating: false,
    request: () => { },
    requestUser: () => { },
    navigateTo: () => { },
    isWebView: isWebview(),
}
export {
    RentalCarDetailContainer,
}

export default connectUrl(mapParamsToProps)(RentalCarDetailContainer)
